module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_Distribution_16"],"path":[{"$":{"d":"M14,2.5a2.5,2.5,0,1,0-3,2.45V8H5V4.95a2.5,2.5,0,1,0-1,0v6.1a2.5,2.5,0,1,0,1,0V9h7V4.95A2.5,2.5,0,0,0,14,2.5Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_Distribution_16.svg
// module id = BaDq
// module chunks = 1